<template>
  <Toaster richColors position="bottom-right" />
  <router-view />
</template>

<script setup>
import { Toaster } from 'vue-sonner';
</script>
